import { render, staticRenderFns } from "./NewBookList.vue?vue&type=template&id=bf83a59c&scoped=true&"
import script from "./NewBookList.vue?vue&type=script&lang=js&"
export * from "./NewBookList.vue?vue&type=script&lang=js&"
import style0 from "./NewBookList.vue?vue&type=style&index=0&id=bf83a59c&scoped=true&lang=scss&"
import style1 from "./NewBookList.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./NewBookList.vue?vue&type=style&index=2&id=bf83a59c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf83a59c",
  null
  
)

export default component.exports